"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_fat = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_fat = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAZCAIAAACpVwlNAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwAAADsABataJCQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAR5JREFUSEvtkq+SRVAcxwUPIAiCIIqCBxA8ggfYIIqCYEYUBEEQNwo3iKLgAQRBFARBEAXBfq/f2Zm77g1r72o+c2b8/p3PnANu5c5a2+MMLvWOS73jWf3xkzAMqT5NE9KmaSil7iOu61KL8axGJYqiz2+KoqB6mqaKokBBKXUxiXmKb7cbtRgv1V3XseQBXdfzPBcEAcdnpXXF5N3wkl+q67qWJGlZFsuy4jhm1T+oZVnG3Ym+71F0HMfzPAQ4uKqq2+Cdw+qqqrCHwEnneRZF0bbtIAh838dAWZY0jIFjamxgyUaWZZqm0bcCeCeAWu+qTdNMkoQl69q2Lc/zwzAgfkuNGKJxHFm+YRgG/e/H1P/Gpd5xqXcw9RmL474AMSRI5wTH038AAAAASUVORK5CYII=",
    iconSize: [30, 25],
});
